import { render } from "./ContactsTitle.vue?vue&type=template&id=9c76bd76&ts=true"
import script from "./ContactsTitle.vue?vue&type=script&lang=ts"
export * from "./ContactsTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__